export default __webpack_public_path__ + "static/ti_bike_white-017f906d1da7188148017be0f58168be.svg";